import { STUDENT_PERFORMANCE_MODAL_ACTION_TYPE } from "../actions-type";

const initalState = {
  studentPerformanceModalData: {},
  studentPerformanceOpenModal: false,
  studentPerformanceModalLoading: false,
};

export const studentPerformanceModalReducer = (state = initalState, action) => {
  switch (action.type) {
    case STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_MODAL:
      return {
        ...state,
        studentPerformanceModalData: action.payload.data,
        studentPerformanceOpenModal: action.payload.openModal,
      };
    case STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL:
      return {
        ...state,
        studentPerformanceOpenModal: action.payload,
      };
    case STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_MODAL_LOADING:
      return {
        ...state,
        studentPerformanceModalLoading: action.payload,
      };
    default:
      return state;
  }
};
